import Image from "next/future/image";
import ArrowLink from "./ArrowLink";
import Link from "next/link";

const NextUp = ({ caseStudy, segue, className = "" }) => {
  return (
    <section
      className={`relative max-w-xl px-6 py-10 lg:py-24 mx-auto xxl:px-0 lg:max-w-screen-xl ${
        className && className
      }`}
    >
      <h4 className="text-2xl lg:text-5xl font-extrabold">Next Up</h4>
      <div className="relative flex flex-col lg:grid lg:grid-cols-2 lg:gap-20 pt-8 lg:pt-12">
        <div>
          <Image
            className="rounded-lg object-cover block"
            src={caseStudy.thumbnail}
            width={596}
            height={397}
            alt={caseStudy.title}
          />
        </div>
        <Link href={`/case-studies/${caseStudy.slug}`}>
          <a className="flex flex-col justify-center">
            <span className="text-xl leading-7 lg:text-4xl font-extrabold lg:leading-10 pt-4">
              {segue}
            </span>
            <p className="text-base leading-6 lg:text-xl font-normal lg:leading-7 text-gray-link py-2">
              {caseStudy.subtitle}
            </p>
            <ArrowLink color="red" linkText={caseStudy.title} />
          </a>
        </Link>
      </div>
    </section>
  );
};
export default NextUp;
